(function () {
    function initStickyElement() {
      var stickyElement = document.querySelector('.sticky-element');

      if (!stickyElement) return;

      function toggleStickyElement() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var pageHeight = document.documentElement.scrollHeight - window.innerHeight;
        var scrollPercent = pageHeight > 0 ? (scrollTop / pageHeight) * 100 : 0;

        if (scrollPercent >= 20) {
          stickyElement.classList.add('show-sticky');
        } else {
          stickyElement.classList.remove('show-sticky');
        }
      }

      window.addEventListener('scroll', toggleStickyElement, { passive: true });
      toggleStickyElement();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStickyElement);
    } else {
      initStickyElement();
    }
  })();